import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const prefix = "fal";
const iconName = "file-arrow-up";
const width = 384;
const height = 512;
const unicode = "f574";
const svgPathData =
  "M365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448zM180.7 228.7l-80 80c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0L176 278.6V400c0 8.844 7.156 16 16 16s16-7.156 16-16V278.6l52.69 52.69C263.8 334.4 267.9 336 272 336s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62l-80-80C197.1 222.4 186.9 222.4 180.7 228.7z";

export const faFileArrowUp: IconDefinition = {
  prefix,
  iconName,
  icon: [width, height, [], unicode, svgPathData],
};
